import { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Link } from "react-router-dom";
import axios from "axios";
import IsLoading from "../../isLoading";
// import from MUI
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import SearchIcon from "@mui/icons-material/Search";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import TocOutlinedIcon from "@mui/icons-material/TocOutlined";

import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

let dataFetch;

function CardView() {
  const qrPayload = JSON.stringify({
    admission_number: dataFetch?.staffID || "",
    first_Name: dataFetch?.personalInfo?.first_Name || "",
    sur_Name: dataFetch?.personalInfo?.sur_Name || "",
    other_Name: dataFetch?.personalInfo?.other_Name || "",
    email: dataFetch?.personalInfo?.email || "",
    phone_number: dataFetch?.personalInfo?.phone_number || "",
  });

  return (
    <div className="g g3 rwdG3 space3">
      {dataFetch?.map((response, index) => {
        return (
          <figure className="couresOfStudyCard fx-cl space1">
            <div
              className="fx-jc space1"
              style={{
                color: "#6693fa",
                fontSize: "1.6rem",
                fontFamily: "serif",
              }}
            >
              <em>somw thein here</em>
            </div>
            <div className="fx-jb">
              <figure
                className="fx-ac fx-jc"
                style={{
                  border: "1px solid #f3f3f3",
                  width: "15rem",
                  height: "15rem",
                }}
              >
                {response.personalInfo?.passport ? (
                  <img src={response.personalInfo?.passport} alt="gal" />
                ) : (
                  response.first_Name?.slice(0, 1).toUpperCase()
                )}
              </figure>
              <figure
                className="fx-ac fx-jc"
                style={{
                  border: "1px solid #f3f3f3",
                  width: "15rem",
                  height: "15rem",
                }}
              >
                {response.personalInfo?.signature ? (
                  <img src={response.personalInfo?.signature} alt="gal" />
                ) : (
                  "No signature on this Account"
                )}
              </figure>
              {dataFetch && (
                <QRCodeCanvas
                  value={JSON.stringify({
                    staff_ID: response?.staffID || "",
                    first_Name: response?.personalInfo?.first_Name || "",
                    sur_Name: response?.personalInfo?.sur_Name || "",
                    other_Name: response?.personalInfo?.other_Name || "",
                    email: response?.personalInfo?.email || "",
                    phone_number: response?.personalInfo?.phone_number || "",
                  })}
                  size={200}
                  style={{ margin: "1rem" }}
                />
              )}
            </div>
            <div className="g g2 ">
              <td></td>
              <td>{response.personalInfo?.gender}</td>
              <td></td>
              <td></td>
              <td>{response.contactInfo?.email}</td>
              <td>
                <span></span>
              </td>
              <span>First Name: {response?.personalInfo.first_Name}</span>
              <span>Sur Name: {response?.personalInfo.sur_Name}</span>
              <span>Other Name: {response?.personalInfo.other_Name}</span>
              <span>Adm No: {response.admission_number}</span>
              <span>Phone No: +234{response.contactInfo?.phone_number}</span>
              <span>Department:{response.academicInfo?.department}</span>
              <span>Programme: {response.academicInfo?.programme}</span>
              <span>
                State: {response.personalInfo?.contact_address?.state}
              </span>
            </div>
            <div className="fx-ac fx-jc space1">
              <button
                style={{
                  backgroundColor: "#6693fa",
                  color: "#fff",
                }}
              >
                <RemoveRedEyeOutlinedIcon />
              </button>
              <button
                style={{
                  backgroundColor: "#f35e6a",
                  color: "#fff",
                }}
              >
                <PrivacyTipOutlinedIcon />
              </button>
              <button
                style={{
                  backgroundColor: "#00d285",
                  color: "#fff",
                  width: "12rem",
                }}
              >
                Action
              </button>
            </div>
          </figure>
        );
      })}
    </div>
  );
}
export default function StaffIdentity() {
  const [loading, setLoading] = useState(false);
  const [changeview, setChangeView] = useState("");
  const [appNo, setAppNo] = useState("");

  //
  async function findApplicationNo() {
    const admission_number = appNo;

    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/reset_password/find_student`,
        {
          admission_number,
        }
      )
      .then((response) => {
        dataFetch = response.data.response;
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }
  async function getApplicants() {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_SERVER_SCRIPT_HOST}/fetch_mconsstaff_data`)
      .then((response) => {
        dataFetch = response.data.info;
        console.log(dataFetch);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  useEffect(() => {
    getApplicants();
  }, []);

  return (
    <>
      {loading ? (
        <IsLoading />
      ) : (
        <div className=" students_data">
          <div className="fx-cl">
            <header className="fx-ac fx-jb space4">
              <div className="adminSearchCont">
                <span style={{ fontSize: "1.2rem" }}>
                  Search admission number
                </span>

                <div className="adminSearch fx-jb">
                  <input
                    type="text"
                    name="application_number"
                    placeholder="im looking for..."
                    onChange={(event) => setAppNo(event.target.value)}
                    value={appNo}
                  />
                  <button
                    onClick={() => alert("no function running currently")}
                  >
                    <SearchIcon fontSize="large" />
                  </button>
                </div>
              </div>

              <div className="fx-ac space2">
                <span onClick={() => setChangeView("table")}>
                  <TocOutlinedIcon />
                </span>
                <span onClick={() => setChangeView("grid")}>
                  <AppsOutlinedIcon />
                </span>
              </div>
            </header>
          </div>
          <CardView />
        </div>
      )}
    </>
  );
}
